var quizQuestions = [
    {
        question: "Which US President graduated from UM with a bachelor's degree in Economics?",
        answers: [
            {
                type: "incorrect",
                content: "Herbert Hoover"
            },
            {
                type: "correct",
                content: "Gerald Ford"
            },
            {
                type: "incorrect",
                content: "Harry Truman"
            },
            {
              type: "incorrect",
              content: "Jimmy Carter"
          }
        ]
    },
    {
      question: "Which of the following is NOT an election hashtag being promoted by the University?",
      answers: [
          {
              type: "correct",
              content: "#GoBlueGoVote"
          },
          {
              type: "incorrect",
              content: "#VotingIsSexy"
          },
          {
              type: "incorrect",
              content: "#SpeakActVote"
          },
          {
            type: "incorrect",
            content: "#UmichVotes"
        }
      ]
    },
    {
      question: "Which Big 10 School saw the greatest increase in voter turnout from 2014 to 2018?",
      answers: [
          {
              type: "incorrect",
              content: "Iowa State University"
          },
          {
              type: "incorrect",
              content: "Penn State"
          },
          {
              type: "incorrect",
              content: "University of Michigan"
          },
          {
            type: "correct",
            content: "Rutgers University"
        }
      ]
    },
    {
      question: "The University of Michigan was originally scheduled to host the Oct. 15 presidential debate, but withdrew due to public health concerns. Where was the debate held instead?",
      answers: [
          {
              type: "incorrect",
              content: "Oxford, Ohio"
          },
          {
              type: "incorrect",
              content: "Pittsburgh, Pennsylvania"
          },
          {
              type: "incorrect",
              content: "Wilmington, North Carolina"
          },
          {
            type: "correct",
            content: "Miami, Florida"
        }
      ]
    },
    {
      question: "Two Regents of the University of Michigan are on the ballot this year. How long is a Regent’s term?",
      answers: [
          {
              type: "incorrect",
              content: "3 years"
          },
          {
              type: "correct",
              content: "8 years"
          },
          {
              type: "incorrect",
              content: "5 years"
          },
          {
            type: "incorrect",
            content: "10 years"
        }
      ]
    },
    {
      question: "Which candidates did The Michigan Daily opinion section endorse in the 2016 Democratic and Republican primaries?",
      answers: [
          {
              type: "incorrect",
              content: "Bernie Sanders / John Kasich"
          },
          {
              type: "incorrect",
              content: "Hillary Clinton / Marco Rubio"
          },
          {
              type: "incorrect",
              content: "Bernie Sanders / Marco Rubio"
          },
          {
            type: "correct",
            content: "Hillary Clinton / John Kasich"
        }
      ]
    },
    {
      question: "How many electors does Michigan have in the electoral college?",
      answers: [
          {
              type: "incorrect",
              content: "7"
          },
          {
              type: "incorrect",
              content: "12"
          },
          {
              type: "incorrect",
              content: "19"
          },
          {
            type: "correct",
            content: "16"
        }
      ]
    },
    {
      question: "What percentage of eligible Michigan students voted in the 2016 election?",
      answers: [
          {
              type: "incorrect",
              content: "15.3%"
          },
          {
              type: "incorrect",
              content: "27.9%"
          },
          {
              type: "incorrect",
              content: "55.9%"
          },
          {
            type: "correct",
            content: "44.7%"
        }
      ]
    }
  ];
  
  export default quizQuestions;
    